import {COLORS} from 'constants/index'

export default {
    root: {
        color: COLORS.apariBlack80
    }
};
